import React from 'react';
import styles from './styles.module.scss';

export interface FilterChipProps {
  label: string;
  /** Toggle state, exposed to assistive tech via `aria-pressed`. */
  pressed: boolean;
  onClick: () => void;
  /** Optional node rendered before the label (e.g. a status dot). */
  leading?: React.ReactNode;
  /** Optional tabular count rendered after the label. */
  count?: number;
  /** `pill` (default) — 40px capsule; `rounded` — compact 32px, 6px corners. */
  shape?: 'pill' | 'rounded';
  testId?: string;
  className?: string;
}

/**
 * Pill-shaped toggle button for list filters. Pressed state inverts the fill
 * (`--header` background, `--widget` text) so it reads in both themes.
 */
export const FilterChip: React.FC<FilterChipProps> = ({
  label,
  pressed,
  onClick,
  leading,
  count,
  shape = 'pill',
  testId,
  className,
}) => (
  <button
    type="button"
    className={[styles.chip, shape === 'rounded' ? styles.rounded : null, className].filter(Boolean).join(' ')}
    aria-pressed={pressed}
    onClick={onClick}
    data-testid={testId}
  >
    {leading}
    <span className={styles.label}>{label}</span>
    {count !== undefined && <span className={styles.count}>{count}</span>}
  </button>
);

export default FilterChip;
